<template>
  <section>
    <ul v-show="footerMenuList.length > 0" class="c-nav-bot js-push-to-right">
      <li :class="{'is-active': acMenu == 'top'}">
        <router-link to="/top" class="c-nav-bot__item" :class="{'is-active': acMenu == 'top'}" @click.native="closeMenu()">
          <div class="c-nav-bot__item--icon">
            <svg class="c-nav-bot__item--img-unactive" width="20" height="20">
              <use xlink:href="#ic-icon-home" />
            </svg>
            <svg class="c-nav-bot__item--img-active" width="20" height="20">
              <use xlink:href="#ic-icon-home-active" />
            </svg>
          </div>
          <div class="c-nav-bot__item--text">ホーム</div>
        </router-link>
      </li>
      <li :class="{'is-active': acMenu == (getFirstMenuItem?.pagename || 'search')}">
        <router-link :to="`${getFirstMenuItem ? getFirstMenuItem.link : '/shop/list'}`"
                    class="c-nav-bot__item relative"
                    :class="{'is-active': acMenu == (getFirstMenuItem?.pagename || 'search')}">
          <div class="c-nav-bot__item--icon">
            <svg class="c-nav-bot__item--img-unactive"
                :width="`${getFirstMenuItem ? getFirstMenuItem.w : '24.48'}`"
                :height="`${getFirstMenuItem ? getFirstMenuItem.h : '21.51'}`"
            >
              <use :xlink:href="`${getFirstMenuItem ? getFirstMenuItem.icon : '#ic-icon-shop'}`" />
            </svg>
            <svg class="c-nav-bot__item--img-active"
                :width="`${getFirstMenuItem ? getFirstMenuItem.w : '24.48'}`"
                :height="`${getFirstMenuItem ? getFirstMenuItem.h : '21.51'}`"
            >
              <use :xlink:href="`${getFirstMenuItem ? getFirstMenuItem.icon : '#ic-icon-shop'}-active`" />
            </svg>
          </div>
          <div class="c-nav-bot__item--text" v-if="getFirstMenuItem?.name == 'ショップニュース'">ショップ<br>ニュース</div>
          <div class="c-nav-bot__item--text" v-else>{{ getFirstMenuItem?.name || 'ショップ' }}</div>
          <div v-if="footerLotterCount > 0 && getFirstMenuItem?.menuType == 4" class="c-nav-i-count">
            <div class="i-count"> {{footerLotterCount}}</div>
          </div>
          <div v-if="footerCouponCount > 0 && getFirstMenuItem?.menuType == 5" class="c-nav-i-count">
            <div class="i-count"> {{footerCouponCount}}</div>
          </div>
        </router-link>
      </li>
      <li>
        <button class="c-nav-bot__item c-nav-menu-btn i-count-wrap">
          <div>
            <Logo />
          </div>
        </button>
      </li>
      <li v-for="(f_menu, index) in filteredFooterMenuList" :key="index" class="i-count-wrap" :class="{'is-active': acMenu == f_menu['pagename']}">
         <router-link :to="f_menu['link']" class="c-nav-bot__item" :class="{'is-active': acMenu == f_menu['pagename']}" @click.native="closeMenu()">
          <div class="c-nav-bot__item--icon">
            <svg class="c-nav-bot__item--img-unactive" :width="f_menu['w']" :height="f_menu['h']">
              <use :xlink:href="f_menu['icon']" />
            </svg>
            <svg class="c-nav-bot__item--img-active" :width="f_menu['w']" :height="f_menu['h']">
              <use :xlink:href="f_menu['icon'] + '-active'" />
            </svg>
          </div>
          <div class="c-nav-bot__item--text" v-if="f_menu['name'] == 'ショップニュース'">ショップ<br>ニュース</div>
          <div class="c-nav-bot__item--text" v-else>{{f_menu['name']}}</div>
          <div v-if="footerLotterCount > 0 && f_menu['menuType'] == 4" class="c-nav-i-count">
            <div class="i-count"> {{footerLotterCount}}</div>
          </div>
          <div v-if="footerCouponCount > 0 && f_menu['menuType'] == 5" class="c-nav-i-count">
            <div class="i-count"> {{footerCouponCount}}</div>
          </div>
        </router-link>
       </li>
    </ul>

    <div class="layer" :class="{ fade: !loading }"></div>
    <loader :loading="loading" />
  </section>
</template>

<script>
import "core-js/stable";
import "regenerator-runtime/runtime";
import Vue from "vue";
import store from "../store";
import { getFooterShopMenu,getShopMenu, getLocalCampaignList, getServerCampaignList, getServerListCoupon } from "../store/firestore.js";
import loader from "./parts/loader.vue"
import Logo from "./Logo.vue";
import { mapState, mapActions } from "vuex";
export default Vue.extend({
  name: 'footer_page',
  props: ['page', 'loading'],
  store,
  components: {
    loader,
    Logo
  },
   data() {
    return {
      getLocalCampaignList: getLocalCampaignList,
      getServerCampaignList: getServerCampaignList,
      defaultFooterMenuList: [
        // {menuType: 1, name: "来店予約", display: false, sort: 3, link: "/shop/list?type=reservation", pagename:"reservation", w: "29", h: "31", icon: "#ic-icon-reservation"},
        {menuType: 2, name: "イベント", display: true, sort: 2, link: "/events", pagename:"events", w: "24", h: "20", icon: "#ic-icon-event"},
        {menuType: 3, name: "チラシ", display: false, sort: 4, link: "/store/flyer", pagename:"flyer", w: "25", h: "31", icon: "#ic-icon-flyer"},
        {menuType: 4, name: "抽選会", display: false, sort: 5, link: "/campaign/list", pagename:"campaign", w: "22", h: "22", icon: "#ic-icon-campaign"},
        {menuType: 5, name: "クーポン", display: true, sort: 1, link: "/coupons", pagename:"event_information", w: "24", h: "20", icon: "#ic-icon-coupon"},
        // {menuType: 6, name: "お気に入り", display: false, sort: 6, link: "/account/favorite", pagename:"favorite", w: "24", h: "20", icon: "#ic-icon-favorite"},
        {menuType: 7, name: "ショップ", display: false, sort: 7, link: "/shop/list", pagename:"search", w: "24", h: "20", icon: "#ic-icon-shop"},
        {menuType: 8, name: "ショップニュース", display: false, sort: 8, link: "/news", pagename:"news", w: "24", h: "20", icon: "#ic-icon-notification"},
      ],
      footerMenuList : [],
      toggleMenu: false,
      acMenu: "",
      lotterCount: 0,
    }
  },
  computed: {
    ...mapState({
      footerLotterCount: state => state.footerLotterCount,
      footerCouponCount: state => state.footerCouponCount
    }),
    getFirstMenuItem() {
      return this.footerMenuList.length > 2 ? this.footerMenuList[0] : null;
    },
    filteredFooterMenuList() {
      return this.footerMenuList.filter(f_menu => f_menu !== this.getFirstMenuItem);
    },
  },

  async created () {
    const shopId = store.getters.shopId;
    this.footerShopMenu = await getFooterShopMenu(shopId);
    this.shopMenu = await getShopMenu(shopId);

    //footer menu
    for (let i = 0; i < this.defaultFooterMenuList.length; i++) {
      const menu = this.defaultFooterMenuList[i];
      const data = this.footerShopMenu?.find(item => {
        return item.menuType == menu.menuType;
      });
      if (data) {
        this.defaultFooterMenuList[i].display = data.display;
        this.defaultFooterMenuList[i].sort = data.sort;
      }
      if (this.defaultFooterMenuList[i].display) {
        this.footerMenuList.push(this.defaultFooterMenuList[i]);
      }
    }
    this.footerMenuList.sort((a, b) => {
      if(a.sort > b.sort) return 1;
      if(a.sort < b.sort) return -1;
      return 0;
    });

    let showReservationMenu = false;
    this.footerMenuList.forEach(f_menu => {
      if (f_menu.menuType == 1 && f_menu.display) {
        showReservationMenu = true;
      }
    });
    const fullPath = this.$route.fullPath;
    if (this.page && this.page.includes('top')) {
      this.acMenu = 'top';
    } else if (this.page && this.page.includes('search') && (!showReservationMenu || !fullPath.startsWith('/shop/list?type=reservation'))) {
      this.acMenu = 'search';
    } else {
      this.footerMenuList.forEach(f_menu => {
        if (f_menu.display && fullPath.startsWith(f_menu['link'])) {
          this.acMenu = f_menu['pagename'];
        }
      });
    }
    const [coupons, campaign] = await Promise.all([
      this.$route.name !== 'Coupons' ? getServerListCoupon(this.$store.state.userId, true) : null,
      getServerCampaignList(true)
    ]);

    if (coupons) {
      this.setFooterCouponCount(coupons);
    }

    if (campaign) {
      this.setFooterLotterCount(campaign.length);
    }
  },
  methods:{
    ...mapActions(['setFooterCouponCount', 'setFooterLotterCount']),
    toggleMenuBtn() {
      this.toggleMenu = !this.toggleMenu
    },
    closeMenu() {
      this.toggleMenu = false
    }
  }
})
</script>
